/* global axios */
import ApiClient from '../ApiClient';

// Canais sociais da Meta (Instagram Direct e Messenger) servidos pela WAME.
// Um recurso só para os dois: a diferença entre eles é o campo `provider`.
class WameSocialChannel extends ApiClient {
  constructor() {
    super('wame/social_channels', { accountScoped: true });
  }

  // Devolve os canais já criados e as chaves WAME disponíveis para esta conta,
  // com a indicação de quais ainda aceitam Instagram e quais aceitam Messenger.
  list() {
    return axios.get(this.url);
  }

  // Cria o canal e a inbox e devolve a URL de autorização da Meta. O canal nasce
  // sem conta vinculada — quem vincula é a autorização.
  connect({ provider, name, teamId, returnUrl }) {
    return axios.post(this.url, {
      provider,
      name,
      team_id: teamId,
      return_url: returnUrl,
    });
  }

  // Relê o estado da instância na WAME. É como se descobre que a autorização
  // terminou: o retorno do OAuth acontece no navegador, sem aviso ao servidor.
  sync(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync`);
  }

  // Refaz a autorização de um canal que já existe. A WAME reconhece a instância
  // pela chave e substitui a autorização anterior.
  reauthorize(inboxId, returnUrl) {
    return axios.post(`${this.url}/${inboxId}/reauthorize`, {
      return_url: returnUrl,
    });
  }

  identify(inboxId, username) {
    return axios.patch(`${this.url}/${inboxId}/identity`, { username });
  }

  verifyIdentity(inboxId) {
    return axios.post(`${this.url}/${inboxId}/verify_identity`);
  }

  disconnect(inboxId) {
    return axios.delete(`${this.url}/${inboxId}`);
  }

  discard(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/discard`);
  }

  removalPreview(inboxId) {
    return axios.get(`${this.url}/${inboxId}/removal_preview`);
  }

  remove(inboxId, confirmationCode) {
    return axios.delete(`${this.url}/${inboxId}/remove`, {
      data: { confirmation_code: confirmationCode },
    });
  }
}

export default new WameSocialChannel();
